import React from 'react';

import i18n from '@i18n';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import TicketPicker from '@/forum/ticketpicker/view/TicketPicker';

function TicketPickerDialog({ oddsLimit, pick, postType, status, topic, type, onClose }) {
    return (
        <Docked className="dialog-ticket-picker" onClose={onClose}>
            <DialogTitle>
                <h2>{i18n('dialog.ticketpicker.title')}</h2>
            </DialogTitle>
            <DialogBody>
                <TicketPicker
                    oddsLimit={oddsLimit}
                    pick={pick}
                    postType={postType}
                    status={status}
                    topic={topic !== 'betboook-null-undefined' ? topic : 'topics'}
                    type={type}
                />
            </DialogBody>
        </Docked>
    );
}
export default TicketPickerDialog;
